/* eslint-disable no-param-reassign */

import produce from 'immer';

import {OauthClientEditorAction, OauthClientEditorActionTypesEnum} from './oauthClientEditorActions';
import {OauthClientEditorState} from './oauthClientEditorState';

export function oauthClientEditorReducer(
  state: OauthClientEditorState,
  action: OauthClientEditorAction,
): OauthClientEditorState {
  switch (action.type) {
    case OauthClientEditorActionTypesEnum.UPDATE_REDIRECT_URLS:
      return updateOauthClientRedirectUrlsReducer(state, action.redirectUrls);

    default:
      return state;
  }
}

/*
 * Helpers.
 */

function updateOauthClientRedirectUrlsReducer(state: OauthClientEditorState, redirectUrls: string[]) {
  return produce(state, (draft) => {
    draft.oauthClientState.redirectUrls = redirectUrls;
  });
}
